import { useState, useEffect, useRef } from 'react';
import { X, Zap } from 'lucide-react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BreakingNewsTicker() {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const eventSourceRef = useRef(null);

  useEffect(() => {
    // Initial load via REST
    axios.get(`${API}/api/breaking-news`).then(r => setItems(r.data?.items || [])).catch(() => {});

    // Try SSE for real-time updates
    try {
      const es = new EventSource(`${API}/api/breaking-news/stream`);
      es.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.items) setItems(data.items);
        } catch {}
      };
      es.onerror = () => { es.close(); };
      eventSourceRef.current = es;
    } catch {
      // Fallback to polling
      const interval = setInterval(() => {
        axios.get(`${API}/api/breaking-news`).then(r => setItems(r.data?.items || [])).catch(() => {});
      }, 15000);
      return () => clearInterval(interval);
    }

    return () => { if (eventSourceRef.current) eventSourceRef.current.close(); };
  }, []);

  if (items.length === 0 || dismissed) return null;

  return (
    <div className="bg-gradient-to-r from-red-600 to-red-500 text-white py-1.5 overflow-hidden relative" data-testid="breaking-news-ticker">
      <div className="max-w-screen-2xl mx-auto px-4 flex items-center gap-3">
        <span className="flex-shrink-0 bg-white text-red-600 px-2.5 py-0.5 rounded-full text-[10px] font-display font-bold uppercase tracking-wider flex items-center gap-1 animate-pulse">
          <Zap size={10} />
          BREAKING
        </span>
        <div className="overflow-hidden flex-1">
          <div className="animate-marquee whitespace-nowrap flex gap-12">
            {items.map(item => (
              <a
                key={item.id}
                href={item.link || '#'}
                className="inline-block text-sm font-display hover:underline"
                data-testid={`breaking-item-${item.id}`}
              >
                {item.priority === 'urgent' && <span className="mr-1 text-yellow-300">&#9679;</span>}
                {item.text}
              </a>
            ))}
            {items.map(item => (
              <a key={`dup-${item.id}`} href={item.link || '#'} className="inline-block text-sm font-display hover:underline">
                {item.text}
              </a>
            ))}
          </div>
        </div>
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 p-1 hover:bg-white/10 rounded transition-colors" data-testid="breaking-dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
